import React from 'react'
// import ScrollToViewGallery from "../../scrollToViewGallery";
// import Example from "../../example";
// import ParallaxOutlineText from "../../parallaxOutlineText";
import AboutUsHeader from "../../aboutUsHeader";
import HorizontalScroll from "../../horizontalScroll";
import ContactSection from "../../contactSection";

const AboutUsPage = () => {
    return (
        <>
            <AboutUsHeader/>
            <HorizontalScroll />
            <ContactSection />
        </>
    )
}

export default AboutUsPage;